<template></template>
<script>
  import 'jquery-validation'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  
  export default {
    name: 'ImportMagazines',
    methods: {
      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      }
    },
    mounted () {
      const vm = this
      
      /**
       * Init JQuery validation
       */
      $(() => {
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            label.insertAfter(element)
            label.addClass('invalid-feedback')
          },
          rules: {
            magazines_file: {
              required: true,
              extension: 'csv',
              maxsize: (vm.isAdmin() ? 5 : 2) * 1024 * 1024,
            },
          },
          messages: {
            magazines_file: {
              required: 'Este campo es requerido.',
              extension: 'El formato del archivo debe tener la extensión CSV.',
              maxsize: `El tamaño del archivo no debe superar los ${ vm.isAdmin() ? 5 : 2 } MB.`,
            },
          },
          submitHandler (form) {
            $('#btn-save .spinner-border').removeClass('d-none')
            $('#btn-save').prop('disabled', true)
            $('#btn-cancel').addClass('disabled')
  
            form.submit()
          },
        })
                
        $('#btn-cancel').on('click', (e) => {
          e.preventDefault()
          
          history.back()
        })
      })
    },
  }
</script>
